/* eslint-disable max-len */
/* ============
 * Create Page
 * ============
 *
 * This page creates client.
 */

import { mapGetters, mapMutations } from 'vuex';
import addClientGroup from './../../clientGroups/create/create.vue';
import accountService from './../../../../services/account';
import clientService from './../../../../services/client';
import clientGroupService from './../../../../services/client-group';
import organizationSettingsService from './../../../../services/organizationSettings';
import clientTypeService from './../../../../services/clientType';
import priceFieldService from './../../../../services/priceField';
import projectService from './../../../../services/project';
import store from './../../../../store';
import clientTransformer from './../../../../transformers/client';
import Forms from './../../../../utils/forms/forms';
import stringFormatMixin from './../../../../mixins/stringFormat';
import actionButtonsPopup from './../../../../components/actionButtonsPopup/actionButtonsPopup.vue';

export default {
  data() {
    return {
      formBasicInformation: new Forms({
        clientGroupId: {
          value: '',
          type: 'select',
        },
        isProducer: {
          value: 0,
          type: 'switch',
        },
        isSupplier: {
          value: 0,
          type: 'switch',
        },
        typeId: {
          value: '',
          type: 'select',
        },
        firstName: {
          value: '',
          type: 'text',
        },
        lastName: {
          value: '',
          type: 'text',
        },
        organizationNumber: {
          type: 'text',
          value: '',
          attributes: {
            hasButton: true,
            buttonLabel: this.$t('static.clients.organizationNumber'),
            buttonHandler: this.buttonHandler,
            hasButton2: true,
            buttonLabel2: this.$t('button.glnLookup'),
            buttonHandler2: this.buttonHandler2,
          },
        },
        companyName: {
          value: '',
          type: 'text',
        },
        email: {
          value: '',
          type: 'email',
        },
        invoiceSendMethod: {
          value: '',
          type: 'select',
        },
        languageId: {
          value: '',
          type: 'select',
        },
        currencyId: {
          value: '',
          type: 'select',
        },
        projectId: {
          value: '',
          type: 'select',
        },
        externalCustomerNumber: {
          value: '',
          type: 'text',
        },
        orderReference: {
          value: '',
          type: 'text',
        },
        gln: {
          value: '',
          type: 'text',
          attributes: {
            disabled: true,
          },
        },
        glnXKoord: {
          value: '',
          type: 'text',
          attributes: {
            disabled: true,
          },
        },
        glnYKoord: {
          value: '',
          type: 'text',
          attributes: {
            disabled: true,
          },
        },
        billingType: {
          value: '',
          type: 'select',
        },
        automaticBilling: {
          value: '',
          type: 'select',
        },
        billingInterval: {
          value: '',
          type: 'select',
        },
        startBilling: {
          value: '',
          type: 'select',
        },
        priceFieldId: {
          value: '',
          type: 'select',
        },
        dueDays: {
          value: 14,
          type: 'number',
        },
        pricePercentageDiscount: {
          value: '',
          type: 'number',
        },
        picture: {
          value: '',
          type: 'file',
        },
        isSubClient: {
          value: 0,
          type: 'switch',
        },
        clientParent: {
          value: '',
          type: 'autocomplete',
          attributes: {
            isSearch: true,
            searchMethod: this.searchMethod,
            loading: true,
          },
        },
        billMainParent: {
          value: 0,
          type: 'checkbox',
        },
      }),
      addressFormErrors: {
        postal: null,
        fields: [],
      },
      contactFormErrors: {
        primary: null,
      },
      clientAddressNames: null,
      loading: true,
      tabIndex: 'first',
    };
  },

  computed: {
    ...mapGetters({
      clientGroups: 'allClientGroups',
      types: 'allClientTypes',
      priceFields: 'allPriceFields',
      currencies: 'currencies',
      languages: 'languages',
      allProjects: 'allProjects',
      account: 'account',
      organizationSettings: 'organizationSettings',
    }),
  },

  watch: {

    'formBasicInformation.email': function (value) {
      this.formBasicInformation.email = value.replace(/\s+/g, '');
    },

    'formBasicInformation.isSubClient': function (value) {
      if (value == 1) {
        this.formBasicInformation.showField('billMainParent');
        this.formBasicInformation.showField('clientParent');
      } else {
        this.formBasicInformation.hideField('billMainParent');
        this.formBasicInformation.hideField('clientParent');
      }
    },

    'formBasicInformation.automaticBilling': function (automaticBilling) {
      if (automaticBilling !== 'none') {
        let feedData = automaticBilling === 'weekly' ? [
          { id: '1_week', name: this.$t('form.billingInterval.week.options.week1') },
          { id: '2_week', name: this.$t('form.billingInterval.week.options.week2') },
          { id: '3_week', name: this.$t('form.billingInterval.week.options.week3') },
        ] : [
          { id: '1_month', name: this.$t('form.billingInterval.month.options.month1') },
          { id: '2_month', name: this.$t('form.billingInterval.month.options.month2') },
          { id: '3_month', name: this.$t('form.billingInterval.month.options.month3') },
          { id: '4_month', name: this.$t('form.billingInterval.month.options.month4') },
          { id: '5_month', name: this.$t('form.billingInterval.month.options.month5') },
          { id: '6_month', name: this.$t('form.billingInterval.month.options.month6') },
        ];
        this.formBasicInformation.setOptions('billingInterval', feedData);
        this.formBasicInformation.setFieldValue('billingInterval', feedData[0].id);
        this.formBasicInformation.showField('billingInterval');

        feedData = automaticBilling === 'weekly' ? this.daysInWeek() : this.daysInMonth();
        this.formBasicInformation.setOptions('startBilling', feedData);
        this.formBasicInformation.setFieldValue('startBilling', feedData[0].id);
        this.formBasicInformation.showField('startBilling');
      } else {
        this.formBasicInformation.hideField('billingInterval');
        this.formBasicInformation.hideField('startBilling');
      }
    },

    allProjects(allProjects) {
      const options = allProjects.map(project => ({
        id: project.id,
        name: project.name,
      }));
      this.formBasicInformation.setOptions('projectId', [{ id: '', name: '' }, ...options]);
    },

    /**
     * Watches state update to inject on Forms class.
     *
     * @param  {Object} clientGroups The client groups list.
     */
    /* eslint max-len: ["error", 150] */
    clientGroups(clientGroups) {
      this.formBasicInformation.setOptions('clientGroupId', [{ id: '', name: '' }, ...clientGroups.all]);
    },
    /**
     * Watches state update to inject on Forms class.
     *
     * @param  {Object} countries    The countries list.
     */
    types(types) {
      this.formBasicInformation.setOptions('typeId', types.map(type => ({
        id: type.id,
        name: type.name,
      })));
    },

    priceFields(priceFields) {
      const options = priceFields.all.map(type => ({
        id: type.id,
        name: type.name,
      }));
      options.splice(0, 0, { id: '', name: '' });
      this.formBasicInformation.setOptions('priceFieldId', options);
    },

    /**
     * Watches state update to inject on Forms class.
     *
     * @param  {Object} languages    The site languages list.
     */
    languages(value) {
      this.formBasicInformation.setOptions('languageId',
        value.all.map(item => ({
          id: item.id,
          name: item.name,
        })));
    },

    currencies(value) {
      this.formBasicInformation.setOptions('currencyId',
        value.all.map(item => ({
          id: item.id,
          name: item.name,
        })));
    },

    /**
     * Watches the value of the client type.
     */
    'formBasicInformation.typeId': function (typeId) {
      if (typeId.toString() === '1') {
        this.formBasicInformation.hideField('companyName');
        this.formBasicInformation.hideField('organizationNumber');
        if (
          this.formBasicInformation.isHidden('firstName') &&
          this.formBasicInformation.isHidden('firstName')
        ) {
          this.formBasicInformation.showField('firstName');
          this.formBasicInformation.showField('lastName');
        }
      }

      if (typeId.toString() !== '1') {
        this.formBasicInformation.hideField('firstName');
        this.formBasicInformation.hideField('lastName');

        if (this.formBasicInformation.isHidden('companyName')) {
          this.formBasicInformation.showField('companyName');
          this.formBasicInformation.showField('organizationNumber');
        }
      }
    },
  },

  created() {
    this.loading = true;
    this.formBasicInformation.setQuickForm('clientGroupId', addClientGroup);
    Promise.all([
      clientGroupService.all(),
      clientTypeService.all(),
      priceFieldService.all(1),
      accountService.currencies(),
      accountService.languages(),
      projectService.all(),
      organizationSettingsService.show(),
    ]).then((results) => {
      const settings = results[6];
      const defaultDueDays = (settings && settings.defaultDueDays != null) ? Number(settings.defaultDueDays) : 14;
      this.formBasicInformation.setFieldValue('dueDays', defaultDueDays);
      this.loading = false;
      this.checkProjectModule();
    });

    this.formBasicInformation.setOptions('invoiceSendMethod', [
      { id: 'EHF', name: 'EHF' },
      { id: 'EMAIL', name: 'Email' },
    ]);

    this.formBasicInformation.setOptions('billingType', [
      { id: 'single', name: this.$t('form.billingTypes.options.single') },
      { id: 'consolidate', name: this.$t('form.billingTypes.options.consolidate') },
    ]);
    this.formBasicInformation.setFieldValue('billingType', 'single');

    this.formBasicInformation.setOptions('automaticBilling', [
      { id: 'none', name: this.$t('form.automaticBilling.options.none') },
      { id: 'weekly', name: this.$t('form.automaticBilling.options.weekly') },
      { id: 'monthly', name: this.$t('form.automaticBilling.options.monthly') },
    ]);
    this.formBasicInformation.setFieldValue('automaticBilling', 'none');
  },

  methods: {
    ...mapMutations({
      toggleModal: 'TOGGLE_MODAL',
      setModalContent: 'SET_MODAL_CONTENT',
      setModalSize: 'SET_MODAL_SIZE',
      setModalProps: 'SET_MODAL_PROPS',
    }),

    checkProjectModule() {
      this.formBasicInformation.hideField('projectId');
      let hasProject = false;
      if (this.account.modules.length > 0) {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < this.account.modules.length; i++) {
          if (this.account.modules[i].name === 'Project') {
            hasProject = true;
          }
        }
      }
      if (hasProject) {
        this.formBasicInformation.showField('projectId');
      }
    },

    daysInWeek() {
      return [
        { id: 'monday', name: this.$t('form.startBilling.week.options.monday') },
        { id: 'tuesday', name: this.$t('form.startBilling.week.options.tuesday') },
        { id: 'wednesday', name: this.$t('form.startBilling.week.options.wednesday') },
        { id: 'thursday', name: this.$t('form.startBilling.week.options.thursday') },
        { id: 'friday', name: this.$t('form.startBilling.week.options.friday') },
        { id: 'saturday', name: this.$t('form.startBilling.week.options.saturday') },
        { id: 'sunday', name: this.$t('form.startBilling.week.options.sunday') },
      ];
    },

    daysInMonth() {
      return [
        { id: '1', name: `1st ${this.$t('form.startBilling.month.options.day')}` }, { id: '2', name: `2nd ${this.$t('form.startBilling.month.options.day')}` },
        { id: '3', name: `3rd ${this.$t('form.startBilling.month.options.day')}` }, { id: '4', name: `4th ${this.$t('form.startBilling.month.options.day')}` },
        { id: '5', name: `5th ${this.$t('form.startBilling.month.options.day')}` }, { id: '6', name: `6th ${this.$t('form.startBilling.month.options.day')}` },
        { id: '7', name: `7th ${this.$t('form.startBilling.month.options.day')}` }, { id: '8', name: `8th ${this.$t('form.startBilling.month.options.day')}` },
        { id: '9', name: `9th ${this.$t('form.startBilling.month.options.day')}` }, { id: '10', name: `10th ${this.$t('form.startBilling.month.options.day')}` },
        { id: '11', name: `11th ${this.$t('form.startBilling.month.options.day')}` }, { id: '12', name: `12th ${this.$t('form.startBilling.month.options.day')}` },
        { id: '13', name: `13th ${this.$t('form.startBilling.month.options.day')}` }, { id: '14', name: `14th ${this.$t('form.startBilling.month.options.day')}` },
        { id: '15', name: `15th ${this.$t('form.startBilling.month.options.day')}` }, { id: '16', name: `16th ${this.$t('form.startBilling.month.options.day')}` },
        { id: '17', name: `17th ${this.$t('form.startBilling.month.options.day')}` }, { id: '18', name: `18th ${this.$t('form.startBilling.month.options.day')}` },
        { id: '19', name: `19th ${this.$t('form.startBilling.month.options.day')}` }, { id: '20', name: `20th ${this.$t('form.startBilling.month.options.day')}` },
        { id: '21', name: `21st ${this.$t('form.startBilling.month.options.day')}` }, { id: '22', name: `22nd ${this.$t('form.startBilling.month.options.day')}` },
        { id: '23', name: `23rd ${this.$t('form.startBilling.month.options.day')}` }, { id: '24', name: `24th ${this.$t('form.startBilling.month.options.day')}` },
        { id: '25', name: `25th ${this.$t('form.startBilling.month.options.day')}` }, { id: '26', name: `26th ${this.$t('form.startBilling.month.options.day')}` },
        { id: '27', name: `27th ${this.$t('form.startBilling.month.options.day')}` }, { id: '28', name: `28th ${this.$t('form.startBilling.month.options.day')}` },
      ];
    },

    /**
     * Method to store the client
     */
    store() {
      this.loading = false;
      this.formBasicInformation.loading = true;
      const formData = new FormData();
      const client = clientTransformer.send(this.formBasicInformation.data());
      Object.keys(client).map((k) => {
        formData.append(k, client[k]);
        return null;
      });
      clientService
        .store(formData)
        .then((data) => {
          this.clientAddressesTabError = null;
          this.showOptionsModal(data);
          this.formBasicInformation.loading = false;
        })
        .catch((errors) => {
          const formErrors = clientTransformer.fetch(errors);
          this.formBasicInformation.loading = false;
          this.formBasicInformation.recordErrors(formErrors);
          if (this.formBasicInformation.errors.any()) {
            this.tabIndex = 'first';
          }
        });
    },
    showOptionsModal(data) {
      this.setModalContent(() => actionButtonsPopup);
      this.setModalSize('full');
      this.toggleModal(true);
      this.setModalProps({
        alert: {
          title: this.$t('static.clients.create.success'),
          type: 'success',
        },
        buttons: [{
          name: 'create',
          text: this.$t('static.clients.create.addMore'),
          action: () => this.goTo('create'),
        },
        {
          name: 'edit',
          text: this.$t('static.clients.create.gotoEdit'),
          action: () => this.goTo('edit', data),
        },
        {
          name: 'index',
          text: this.$t('static.clients.create.gotoIndex'),
          action: () => this.goTo('index'),
        },
        ],
      });
    },
    goTo(page, data) {
      this.toggleModal(false);
      if (page === 'create') {
        this.formBasicInformation.showField('companyName');
        this.formBasicInformation.showField('organizationNumber');
        this.formBasicInformation.showField('firstName');
        this.formBasicInformation.showField('lastName');
        this.formBasicInformation.resetValues();
      } else if (page === 'edit') {
        this.$router.push({
          name: 'clients.edit',
          params: { id: data.id },
        });
      } else {
        this.$router.push({
          name: 'clients.index',
        });
      }
    },
    buttonHandler() {
      this.formBasicInformation.loading = true;
      const organizationNumber = this.formBasicInformation.organizationNumber;
      this.formBasicInformation.disableField('organizationNumber');

      clientService
        .findBusiness(organizationNumber)
        .then((data) => {
          this.formBasicInformation.loading = false;
          this.formBasicInformation.enableField('organizationNumber');
          this.formBasicInformation.companyName = data.name;
        })
        .catch(() => {
          this.$message({
            message: this.$t('static.clients.create.brrig.warning'),
            type: 'error',
          });
          this.formBasicInformation.enableField('organizationNumber');
          this.formBasicInformation.loading = false;
        });
    },

    buttonHandler2() {
      const organizationNumber = this.formBasicInformation.organizationNumber;
      this.formBasicInformation.loading = true;
      this.formBasicInformation.disableField('organizationNumber');
      clientService.glnLookup(organizationNumber)
      .then((res) => {
        this.formBasicInformation.setFieldValue('gln', res.gln);
        this.formBasicInformation.setFieldValue('glnXKoord', res.xKoord);
        this.formBasicInformation.setFieldValue('glnYKoord', res.yKoord);
        this.formBasicInformation.enableField('organizationNumber');
        this.formBasicInformation.loading = false;
      }).catch((error) => {
        console.log(error);
        this.formBasicInformation.enableField('organizationNumber');
        this.formBasicInformation.loading = false;
      });
    },

    searchMethod(search, field) {
      return Promise.all([
        clientService.all(search),
      ]);
    },
  },

  mounted() {
    this.formBasicInformation.setFieldValue('isSubClient', 0);
    this.formBasicInformation.hideField('billMainParent');
    this.formBasicInformation.hideField('clientParent');
  },

  components: {
    VForm: require('./../../../../components/form/form.vue'),
    VClientAddress: require('./../../../../components/clientAddress/clientAddress.vue'),
    VClientContact: require('./../../../../components/clientContact/clientContact.vue'),
  },

  mixins: [
    stringFormatMixin,
  ],
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/clients/create/create.js